/* sc-pdp-canvas-gesture-router.js — Mobile: neutralize Fabric.js touch preventDefault.
 *
 * Problem: Customily dùng Fabric.js 3.x. Trên mobile, Fabric's `_onTouchStart`
 * gọi `e.preventDefault()` → nuốt cả swipe ngang (đổi slide) lẫn scroll dọc.
 *
 * Why previous approaches failed:
 *   - CSS `touch-action: pan-x pan-y`: browser cho phép scroll, nhưng Fabric
 *     vẫn preventDefault → browser cancel scroll.
 *   - Capture-phase stopImmediatePropagation: Fabric's listener bound trên
 *     canvas element trong bubble phase, nhưng preventDefault vẫn xảy ra trước
 *     khi capture handler của tôi stop được (event dispatch order + passive
 *     binding edge cases).
 *
 * Fix: no-op hóa Fabric.Canvas prototype's touch handlers. Canvas chỉ dùng
 * để preview (render bitmap), user không tương tác trực tiếp với canvas objects.
 * Vô hiệu touch handlers → không preventDefault → native scroll hoạt động.
 *
 * Scope: mobile only (<=749px). Desktop không có gesture conflict nên giữ nguyên
 * Fabric behavior (cho trường hợp tương lai cần canvas interaction trên desktop).
 *
 * Gating: chỉ chạy khi có `window.fabric` + `#cl_optionsapp` trên DOM.
 */
(function () {
  'use strict';

  if (matchMedia('(min-width: 750px)').matches) return;

  var patched = false;

  function neutralize() {
    if (patched) return true;
    if (!window.fabric || !window.fabric.Canvas || !window.fabric.Canvas.prototype) return false;

    var proto = window.fabric.Canvas.prototype;
    var noop = function () { return this; };

    /* Vô hiệu touch handlers — Fabric gọi preventDefault trong các method này.
     * Canvas preview không cần touch interaction trên mobile. */
    if (proto._onTouchStart) proto._onTouchStart = noop;
    if (proto._onTouchEnd) proto._onTouchEnd = noop;
    if (proto._onMouseDown) proto._onMouseDown = noop;
    if (proto._onMouseMove) proto._onMouseMove = noop;
    if (proto._onMouseUp) proto._onMouseUp = noop;

    /* Official Fabric flag — một số internal path đọc flag này để skip preventDefault. */
    proto.allowTouchScrolling = true;
    patched = true;
    return true;
  }

  /* Fabric load async (Customily inject sau DOMContentLoaded).
   * Poll tối đa 20s; drop gate `#cl_optionsapp` vì tồn tại `window.fabric`
   * trên Shrine PDP đã implies Customily. */
  function init() {
    if (neutralize()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (neutralize() || ++tries > 40) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
